<div class="navbar-wrapper">
  <div class="logo-container">
    <img src="assets/img/start-page/HVB_Logo.svg" class="cursor-pointer" alt="HVB Logo"/>
  </div>
</div>
<div class="main-outer-div flex-grow-1 flex-shrink-1 pt-4">
  <div class="left form-title-section-text">
    <h1>{{ 'createUser.createUserTitle' | translate }}</h1>
    <h4>{{ 'createUser.createUserSubtitle' | translate }}</h4>
  </div>

  <div class="d-flex justify-content-between align-items-end form-title-section-buttons" *ngIf="company$|async">
    <button (click)="logout()" class="menu-button w-100 me-4">
      {{'loginPage.logout'|translate}}
    </button>
    <button [disabled]="!(allFormsValid$|async)" (click)="saveUser()"
            data-cy="user-button"
            class="menu-button save-button w-100">{{'createUser.createUser'|translate}}</button>
  </div>

  <div class="left" *ngIf="company$|async">
    <div class="white-box">
      <div class="form-steps-container-title">
        <div class="form-steps-title-section-row-1">
          <div class="form-steps-title-section-left">
            <div class="section-title" style="margin-right: 10px">
              {{'formStepsSection.title'|translate}}
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column " style="float: right; width: 100%">

        <ng-container *ngFor="let title of titles;let i = index">
          <ng-container>
            <div (click)="scroll(idNames[i])" [id]="idNames[i]+'button'"
                 [ngClass]="{'selectedSection': scrolled == i}"
                 class="form-steps-list-row">

              <div class="form-steps-list-row-error-non-visible"
                   [ngClass]="{'form-steps-list-row-error': !(validChildForm[i] | async)&& i < maxScrolled && scrolled!= i}">
                <div class=" form-steps-list-items">
                  <ng-container>
                    <ng-container *ngIf="(validChildForm[i] | async) && maxScrolled >= i">
                      <ng-container *ngTemplateOutlet="validCircle"></ng-container>
                    </ng-container>

                    <ng-container
                      *ngIf="!(validChildForm[i] | async) && i < maxScrolled">
                      <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
                    </ng-container>

                    <ng-container
                      *ngIf="!(validChildForm[i] | async) && i === maxScrolled && i !== scrolled">
                      <ng-container *ngTemplateOutlet="errorIcon"></ng-container>
                    </ng-container>

                    <ng-container
                      *ngIf="i > maxScrolled && i !== scrolled">
                      <ng-container *ngTemplateOutlet="emptyCircle"></ng-container>
                    </ng-container>

                    <ng-container
                      *ngIf="!(validChildForm[i] | async) && scrolled === i && maxScrolled === i">
                      <ng-container *ngTemplateOutlet="selectedCircle"></ng-container>
                    </ng-container>

                  </ng-container>
                  <span class="progress-bar-text">
                        {{(i + 1) + '/3'}}
                    {{'createUser.' + title|translate}}
                  </span>
                </div>
              </div>

            </div>
            <div *ngIf="titles[i+1] !== undefined" class="vertical-line"></div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>


  <div #rightPart id="rightPart" class="right" (scroll)="onWindowScroll(rightPart)" *ngIf="company$|async">

    <div [id]="idNames[0]" class="form-inner-container">
      <app-personal-information-form></app-personal-information-form>
      <hr>
    </div>

    <div [id]="idNames[1]" class="form-inner-container">
      <app-contact-information-form></app-contact-information-form>
      <hr>
    </div>

    <div [id]="idNames[2]" class="form-inner-container margin-bottom-xxl">
      <app-privacy-policy></app-privacy-policy>
      <div class="next-button-container">
        <button [disabled]="!(allFormsValid$|async)" (click)="saveUser()"
                class="menu-button save-button">{{'createUser.createUser'|translate}}</button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="company$|async; else noCompany"></div>

<ng-template #validCircle><span class="circle-valid">
  <mat-icon>done</mat-icon>
                  </span>
</ng-template>

<ng-template #errorIcon><span class="invalid-selected">
  <img alt="warning" src="assets/svg-icons/warning_amber.svg"> </span>
</ng-template>
<ng-template #emptyCircle><span class="circle">
                  </span></ng-template>

<ng-template #selectedCircle><span class="circle selected-circle">
                  </span></ng-template>

<ng-template #noCompany>
  <div class="no-company-container d-flex flex-column justify-content-between">

    <div class="d-flex flex-column flex-grow-1 justify-content-center align-items-center no-company-text-container">
      <img src="assets/svg-icons/circle-actions-alert-info.svg" alt="">
      <span class="big-no-company-text mb-3">
        {{'createUser.noCompany.message'|translate}}
      </span>

      <span class="small-no-company-text">
        {{'createUser.noCompany.procedure'|translate}}
        <a href="mailto:support@hvb.services">support&#64;hvb.services</a>

        {{'\n\n' + ('createUser.noCompany.thanks'|translate)}}
      </span>
    </div>
    <div class="menu-button-container pt-3 w-100 justify-content-center">
      <button class="blue-border" (click)="authService.logout()">{{'loginPage.logout'|translate}}</button>
    </div>
  </div>
</ng-template>
